module.exports = __webpack_public_path__ + "static/media/57F3FBFD-0FF8-481E-A386-4567A2018EAA.980992be.JPG";